require('babel-register');


module.exports = {
  Nobles: require('./nobles').Nobles,
  distanceConverter: require('./distanceConverter'),
  heroImageResolver: require('./heroImageResolver'),
  calculatePace: require('./CalculatePace').calculatePace,
};



/** WEBPACK FOOTER **
 ** ./lib/anuket/index.js
 **/